export default __webpack_public_path__ + "static/video-poblaciones-8f049b8275890d5ac543fc1e8d1514fb.mp4";